var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginhistoryicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_40_1",
    "data-name": "Component 40 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.852,
    height: 52.658,
    viewBox: "0 0 46.852 52.658",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M450.774,508.334v2.272h-4.909c-.124-2-.357-3.983,1.107-5.663a5.153,5.153,0,0,1,4.061-1.778c9.05-.01,18.1-.024,27.148.01a5,5,0,0,1,5.224,5.182q.056,17.451-.009,34.9a4.892,4.892,0,0,1-3.331,4.784q-8.848,3.576-17.685,7.181c-.464.187-.933.355-1.538.586,0-2.191-.042-4.259.019-6.323.027-.913-.224-1.222-1.177-1.2-2.779.062-5.562.027-8.343.021-3.6-.008-5.52-1.9-5.546-5.472,0-.624,0-1.247,0-1.964h4.934v2.371h10.114v-1.331c0-9.128.02-18.254-.027-27.381a1.619,1.619,0,0,1,1.3-1.814c3.492-1.248,6.95-2.592,10.42-3.9a2.129,2.129,0,0,0,.813-.482Z",
    transform: "translate(-436.579 -503.153)",
    fill: "#de7054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M437.5,527.024v-4.986h11.986l-3.882-3.661,3.723-3.587,9.724,9.755-9.811,9.783c-1.078-1.121-2.2-2.289-3.467-3.606l3.978-3.7Z",
    transform: "translate(-437.498 -501.861)",
    fill: "#de7054"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginhistoryicon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/login.history.icon.94e954955a3d6e3dde343b39526d6e34.svg";
export { ForwardRef as ReactComponent };